'use client';

export function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="footer">
      <div className="container">
        <div className="flex flex-col sm:flex-row justify-center sm:justify-between items-center gap-3 py-5">
          <div className="flex items-center gap-2 font-normal text-sm">
            <span className="text-muted-foreground">{currentYear} &copy;</span>
            <span className="text-secondary-foreground font-semibold">Wioker</span>
          </div>
          <div className="text-xs text-muted-foreground">
            Tüm hakları saklıdır.
          </div>
        </div>
      </div>
    </footer>
  );
}
